import { IdentityService } from '../../core/identity/identity.service';
import { Logger, LoggerFactory } from '../../core/logger.service';
import { Environment, ENVIRONMENT_DI } from './../../environment/environment';
import { Component, EventEmitter, Inject, inject, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { AccountAdminService } from 'app/back-office/account-admin.service';
import { SettingsService } from '../../shared/services/admin-settings.service';
import { AdminSettings } from '../../shared/services/admin-settings.model';
import { LanguageService } from '../../core/language.service';
import { TopLevelSideMenuService } from '../top-level-side-menu/top-level-side-menu.service';
import { AgentPanelService } from '../../agents/agent-panel.service';
import { TopMenuTitleService } from '../../shared/services/top-menu-title.service';

@Component({
  selector: 'top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['top-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TopMenuComponent implements OnInit {
  private readonly logger: Logger;
  public version: string;
  public isAdmin: boolean;
  public settings: AdminSettings;

  @Input() public color: string;
  @Input() public currentTitle: string;
  @Output() public closeSideMenu = new EventEmitter<any>();
  @Input() isBetaItem = false;

  private readonly topLevelSideMenuService = inject(TopLevelSideMenuService);
  public readonly topLevelMenuOpen = this.topLevelSideMenuService.mobileOpen;

  private readonly agentPanel = inject(AgentPanelService);
  protected readonly agentPanelEnabled = this.agentPanel.enabled;

  private readonly topMenuTitle = inject(TopMenuTitleService);
  protected readonly pageTitle = this.topMenuTitle.title;
  protected readonly pageTitleVisible = this.topMenuTitle.visible;

  constructor(
    private settingsService: SettingsService,
    public readonly languageService: LanguageService,
    loggerFactory: LoggerFactory,
    public readonly identityService: IdentityService,
    @Inject(ENVIRONMENT_DI) private readonly environment: Environment,
    public readonly accountAdminService: AccountAdminService,
  ) {
    this.logger = loggerFactory.get('TopMenuComponent');
  }

  ngOnInit(): void {
    this.settingsService.settings$.subscribe((settings) => {
      this.settings = settings;
    });
    this.version = 'Triggerbee';
    const identity = this.identityService.currentIdentity;
    if (identity) {
      this.isAdmin = identity.isAdmin();
      if (identity.isAdmin()) {
        this.version += ' 2026.11.04.39';
      }
    }
  }

  public emitCloseSideMenu() {
    this.closeSideMenu.emit();
  }

  public toggleTopLevelMenu(): void {
    this.topLevelSideMenuService.toggleMobileOpen();
  }

  public setMenuForUserApp(): void {
    this.accountAdminService.userBackOfficeBS.next(false);
  }
}
